import Hammer from 'hammerjs'
import {map, curry, pathOr} from 'ramda'

// if mobileSwipeEl is provided, will look at this element to trigger swiping left and right
window.aboundSectionScroll = (leftEl, rightEl, sectionEls, itemsPerPaneDesktop, itemsPerPageMobile, mobileBreakpoint, mobileSwipeEl = undefined) => {
    const positiveOrZero = x => x < 0 ? 0 : x

    const intOrZero = x => !x ? 0 : parseInt(x, 10)

    const setStyle = curry((key, value, el) => {
        el.style[key] = value
        return el
    })
    const getStyle = curry((key, el) => el.style[key])

    const addClass = curry((className, el) => el.classList.add(className))
    const removeClass = curry((className, el) => el.classList.remove(className))

    const setLeft = setStyle('left')
    const getLeft = el => intOrZero(getStyle('left', el))

    const getItemsPerPane = () => {
        return document.body.parentNode.clientWidth > mobileBreakpoint
            ? itemsPerPaneDesktop
            : itemsPerPageMobile
    }

    const getItemPx = () => pathOr(0, [0, 'offsetWidth'], sectionEls)
    const getScrollPx = () => getItemPx() * getItemsPerPane()
    const getFullyRightPx = () => -1 * positiveOrZero(sectionEls.length - getItemsPerPane()) * getItemPx() // substract off one pane of items, because we're fully scrolled on the last pane (not beyond the last pane)

    const scrollLeft = () => {
        if(isScrolledFullyLeft()) return

        map((el) => {
            setLeft((getLeft(el) + getScrollPx()) + 'px', el)
        }, sectionEls)

        updateArrowsEnabled()
    }

    const scrollRight = () => {
        if(isScrolledFullyRight()) return

        map((el) => {
            setLeft((getLeft(el) - getScrollPx()) + 'px', el)
        }, sectionEls)

        updateArrowsEnabled()
    }

    const scrollFullyLeft = () => {
        if(isScrolledFullyLeft()) return

        map((el) => {
            setLeft(0, el)
        }, sectionEls)

        updateArrowsEnabled()
    }

    const isScrolledFullyLeft = () => 0 === intOrZero(pathOr(0, [0, 'style', 'left'], sectionEls))

    const isScrolledFullyRight = () => getFullyRightPx() >= intOrZero(pathOr(0, [0, 'style', 'left'], sectionEls))

    const updateArrowsEnabled = () => {
        isScrolledFullyLeft() ? addClass('disabled', leftEl) : removeClass('disabled', leftEl)
        isScrolledFullyRight() ? addClass('disabled', rightEl) : removeClass('disabled', rightEl)
    }

    updateArrowsEnabled()
    leftEl && leftEl.addEventListener('click', scrollLeft)
    rightEl && rightEl.addEventListener('click', scrollRight)
    ;(leftEl || rightEl) && window.addEventListener('resize', scrollFullyLeft) // reset the scroll if the window changes, or else it will look weird
    if((leftEl || rightEl) && mobileSwipeEl) {
        const hammer = new Hammer(mobileSwipeEl, {})
        hammer.on('swipe', e => {
            if(e.direction === Hammer.DIRECTION_LEFT) scrollRight()
            else if(e.direction === Hammer.DIRECTION_RIGHT) scrollLeft()
        })
    }
}



// WEBPACK FOOTER //
// ./abound-scroll.js